export const MoneyInput = (props: {
  value: string | number | null | undefined;
  onKeyDown?: (e: { currentTarget: { value: string }; key: string }) => void;
  onChange?: (e: { target: { value: string } }) => void;
  onInput?: (e: { target: { value: string } }) => void;
  disabled?: boolean;
}) => {
  return (
    <div>
      <div class="relative flex items-center">
        <span
          class="absolute left-3 text-gray-500 pointer-events-none select-none"
          aria-hidden
        >
          $
        </span>
        <input
          class="w-full pl-7 pr-3 py-2 border rounded-md shadow-xs focus:outline-hidden
            disabled:bg-gray-100 disabled:border-gray-300 disabled:text-gray-500 border-[#80b6cf] focus:border-[#123b50] hover:border-[#123b50]
          "
          value={props.value ?? ''}
          type="number"
          onChange={props.onChange}
          onInput={props.onInput}
          onKeyDown={props.onKeyDown}
          onWheel={(e) => e.preventDefault()}
          disabled={props.disabled}
        />
      </div>
    </div>
  );
};
